import {createContext, useContext} from 'react';
import type {IFormDataV2} from 'src/types/FormV2';

/**
 * Context for sharing form data between form fields.
 * This allows fields to access values from other fields in the same form,
 * enabling inter-field dependencies (e.g., filtering personnel by selected project).
 */
export const FormDataContext = createContext<IFormDataV2 | undefined>(undefined);

/**
 * Hook to access the current form data from context.
 * Returns an empty object if used outside of a FormDataContext provider.
 *
 * @example
 * const formData = useFormData();
 * const projectId = formData['projectId'];
 */
export function useFormData(): IFormDataV2 {
  const context = useContext(FormDataContext);
  if (!context) {
    return {};
  }
  return context;
}
